// Navigation constants
export const MASQUERADE_BAR_HEIGHT = 28;
